import React, { useState, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
//imports ARSIT
import AlertaContext from "context/alertas/alertaContext";
import UsuarioContext from "context/usuario/usuarioContext";
import AuthContext from "context/autentication/authContext";
import MensajeAlerta from "components/MensajeAlerta";
import InputMask from "react-input-mask";
import IconButton from "@material-ui/core/IconButton";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import ValidationsContext from "context/validations/validationsContext";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import ClienteContext from "context/cliente/clienteContext";
import {MdVisibility, MdVisibilityOff} from "react-icons/md";
import DialogActions from "@material-ui/core/DialogActions";
import {TextField, Select, FormControl, MenuItem, Grid} from "@material-ui/core";
import BotonLoading from "components/Buttons/BotonLoading"
import { Role } from "types/roles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
  textField: {
    width: "25ch",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

export default function ActualizarUsuario(props) {
  const classes = useStyles();
  const validationsContext = useContext(ValidationsContext);
  const {validateForm, validateUsername, validateeMail, validatePassword, validateCodigoArea, validateNumeroTelefono } = validationsContext;
  // extraer los valores del context
  const alertaContext = useContext(AlertaContext);
  const { alerta, mostrarAlerta } = alertaContext;
  const clienteContext = useContext(ClienteContext);
  const { clientes, obtenerClientes } = clienteContext;
  const [usuario, guardarUsuario] = useState({
    estado: true,
    id: props.user.id,
    email: props.user.email,
    password: props.user.password,
    nombre: props?.user?.nombre,
    codigoPais: "+549",
    codigoArea: props?.user?.codigoArea?.slice(1,5),
    numeroTelefono: props?.telefono,
    clienteRol: [{
      cliente: {
        estado: true,
        id: props.clienteId,
        razonSocial: props.user.lisCliente,
        logo: "",
        __v: 0
      },
      rol: props.user.rol, default: true,
    }],
    showPassword: false,
  });
  const [listInt, setListInt]= useState([])
  const [open, setOpen] = React.useState(false);
  const usuarioContext = useContext(UsuarioContext);
  const {actualizarUsuario, errorUsuario} = usuarioContext;
  const authContext = useContext(AuthContext);
  const { rol, usuario: us,cliente } = authContext;
  const handleClickShowPassword = () => {
    guardarUsuario({ ...usuario, showPassword: !usuario.showPassword });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const clienteActual = () =>{
    return usuario.clienteRol.filter(c=>c.default)[0]
}
  const cargarListInt = () =>{
    let data=[]
    clientes.map(c=>{data.push(c)})
    data.push(opcion.cliente)
    setListInt(data)
}

  useEffect(() => {
        obtenerClientes(cliente)
        cargarListInt()
  }, [usuario]);

  useEffect(() => {
    guardarUsuario({
      estado: true,
      id: props.user.id,
      email: props.user.email,
      password: props.user.password,
      nombre: props.user.nombre,
      codigoPais: "+549",
      codigoArea: props.user.codigoArea.slice(1,5),
      numeroTelefono: props.user.telefono,
      clienteRol: [{
        cliente: {
          estado: true,
          id: props.clienteId,
          razonSocial: props.user.lisCliente,
          logo: "",
          __v: 0
        },
        rol: props.user.rol, default: true,
      }],
      showPassword: false,
    });
  }, []);
  // estado para la funcion del boton grabar
  const [errors, setErrors] = useState({
    email: "",
    password: "",
    nombre: "",
    codigoArea: "",
    numeroTelefono: "",
  })
  const onChange = (e) => {
    guardarUsuario({
      ...usuario,
      [e.target.name]: e.target.value,
    });
    switch (e.target.name) {
      case 'nombre':
        setErrors({
          ...errors, nombre: validateUsername(e.target.value)
        });
        break;
      case 'email':
        setErrors({
          ...errors, email: validateeMail(e.target.value)
        });
        break;
      case 'password':
        setErrors({
          ...errors, password: validatePassword(e.target.value)
        });
        break;
      default:
        break;
    }
  };
  const control = () => {
    if (usuario.clienteRol[0].rol === Role.Integrador && (us.clienteRol[0].rol === Role.Integrador)) {
      let clienteElegido = clientes.find((cl) => cl.razonSocial === us.clienteRol[0].cliente.razonSocial)
      usuario.clienteRol[0].cliente.razonSocial = us.clienteRol[0].cliente.razonSocial
      /* usuario.clienteRol[0].cliente.id = clienteElegido.id */
    }
  }
  const onSubmit = () => {
    props.refreshUs()
    // Validar que no haya campos vacios
    if (!validateForm(errors) || usuario.nombre.trim() === "" ||
    usuario.email.trim() === "" ||
    usuario.clienteRol[0].rol.trim() === "" ||
    usuario.numeroTelefono.trim() === "" ||
    usuario.codigoArea.trim() === "") {
        errorUsuario("Todos los campos con * son obligatorios", "error");
        return;
    } else {
      control();
      // Pasarlo al action
      actualizarUsuario({
        id: usuario.id,
        estado: usuario.estado,
        email: usuario.email,
        password: usuario.password,
        nombre: usuario.nombre,
        codigoPais: usuario.codigoPais,
        codigoArea: usuario.codigoArea.slice(1, 5),
        numeroTelefono: usuario.numeroTelefono.slice(2, 10),
        clienteRol: usuario.clienteRol,
      });
      props.onClose()
      props.refreshUs()
    }
  };
  
  const seteador = async (x, e) => {
    if (x) {
      usuario.clienteRol[0].rol = x
    }
  }
  const setClientes = async (x, e) => {
    if (x) {
      let clienteElegido = clientes.find((cl) => cl.razonSocial === x)
      usuario.clienteRol[0].cliente.razonSocial = x
      usuario.clienteRol[0].cliente.id = (x!==opcion.cliente.razonSocial) ? clienteElegido.id : opcion.cliente.id
    }
  }
  const opcion = clienteActual();
  return (
    <>
    <div className={classes.form} noValidate onSubmit={onSubmit}>
      <Grid container spacing={1} display="row" justify="center" alignItems="center">
        <Grid item xs={10} md={10} lg={10}>
          <TextField
            error={errors.nombre.length > 0}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="nombre"
            name="nombre"
            label={errors.nombre.length > 0 ? errors.nombre : "Nombre"}
            value={usuario.nombre}
            onChange={onChange}
          />
        </Grid>
        <Grid container spacing={1}  display="row" justify="center" alignItems="center">
          <Grid item xs={10} md={5} lg={5}>
            <TextField 
              error={errors.email.length > 0}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label={errors.email.length > 0 ? errors.email : "Email"}
              name="email"
              value={usuario.email}
              onChange={onChange}
            />
          </Grid>
          <Grid item xs={10} md={5} lg={5}>
            <FormControl variant="outlined" margin="normal" required fullWidth>
              {errors.password.length > 0 ?
                <InputLabel htmlFor="outlined-adornment-password" style={{ color: "red" }} >
                  {errors.password.length > 0 ? errors.password : "Contraseña"}
                </InputLabel> :
                <InputLabel htmlFor="outlined-adornment-password" >
                  Contraseña
                </InputLabel>}
              <OutlinedInput
                error={errors.password.length > 0}
                margin="normal"
                required
                fullWidth
                label={errors.password.length > 0 ? errors.password : "Contraseña"}
                name="password"
                id="outlined-adornment-password"
                type={usuario.showPassword ? "text" : "password"}
                value={usuario.password}
                onChange={onChange}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {usuario.showPassword ? (
                        <MdVisibility />
                      ) : (
                        <MdVisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={1}  display="row" justify="center" alignItems="center">
          <Grid item xs={10} md={5} lg={5}>
            <FormControl variant="outlined" fullWidth margin="normal">
              {rol === Role.Super ?
                <>
                  <InputLabel id="rol-label">
                    Elegir Rol
                  </InputLabel>
                  <Select
                    labelId="newRol"
                    id="newRol"
                    name="newRol"
                    value={usuario.clienteRol[0].rol}
                    /*defaultValue={usuario.clienteRol[0].rol} */
                    onChange={onChange}
                    label="Elegir Rol"
                  >
                    <MenuItem value={Role.Integrador} onClick={(e) => seteador(Role.Integrador, e)}>INTEGRADOR</MenuItem >
                    <MenuItem value={Role.Supervisor} onClick={(e) => seteador(Role.Supervisor, e)}>SUPERVISOR</MenuItem >
                  </Select>
                </> : null}
              {rol === Role.Admin || rol===Role.Soporte ?
                <>
                  <InputLabel id="rol-label">
                    Elegir Rol
                  </InputLabel>
                  <Select
                    labelId="newRol"
                    id="newRol"
                    name="newRol"
                    value={usuario.clienteRol[0].rol}
                    onChange={onChange}
                    label="Elegir Rol"
                  >
                    <MenuItem value={Role.Admin} onClick={(e) => seteador(Role.Admin, e)}>ADMIN</MenuItem >
                    {/* <MenuItem value={Role.Operador} onClick={(e) => seteador(Role.Operador, e)}>OPERADOR</MenuItem > */}
                  </Select>
                </> : null}
              {rol === Role.Integrador ?
                <>
                  <InputLabel id="rol-label">
                    Elegir Rol
                  </InputLabel>
                  <Select
                    labelId="newRol"
                    id="newRol"
                    name="newRol"
                    value={usuario.clienteRol[0].rol}
                    onChange={onChange}
                    label="Elegir Rol"
                  >
                    <MenuItem value={Role.Integrador} onClick={(e) => seteador(Role.Integrador, e)}>INTEGRADOR</MenuItem >
                    <MenuItem value={Role.Admin} onClick={(e) => seteador(Role.Admin, e)}>ADMIN</MenuItem >
                  </Select>
                </>
                : null}
            </FormControl>
          </Grid>
          <Grid item xs={10} md={5} lg={5}>
            <FormControl variant="outlined" fullWidth margin="normal">
              {(rol === Role.Super) ?
                <>
                  <InputLabel id="listClientes-label">
                    Elegir Cliente
                  </InputLabel>
                  <Select
                    labelId="listaC"
                    id="listaC"
                    name="listaC"
                    value={usuario.clienteRol[0].cliente.razonSocial}
                    defaultValue={(e) => setClientes(usuario.clienteRol[0].cliente.razonSocial, e)}
                    onChange={onChange}
                    label="Elegir Cliente"
                  >
                    {clientes.length === 0 ? (
                      <MenuItem value="" >No hay clientes</MenuItem>
                    ) : (
                      clientes.map((cli) => (
                        <MenuItem key={cli.id} value={cli.razonSocial} onClick={(e) => setClientes(cli.razonSocial, e)}>
                          {cli.razonSocial}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </>
                :
                (rol === Role.Integrador) ?
                  ((usuario.clienteRol[0].rol === Role.Admin) ?
                    <>
                      <InputLabel id="listClientes-label">
                        Elegir Cliente
                      </InputLabel>
                      <Select
                        labelId="listaC"
                        id="listaC"
                        name="listaC"
                        value={usuario.clienteRol[0].cliente.razonSocial} 
                        /* defaultValue={(e) => setClientes(props.user.lisCliente,e)} */
                        onChange={onChange}
                        label="Elegir Cliente"
                      >
                        {
                          listInt.length === 0 ? (
                            <MenuItem value="" >No hay clientes</MenuItem>
                          ) : (
                            listInt.map((cli) => (
                              <MenuItem key={cli.id} value={cli.razonSocial} onClick={(e) => setClientes(cli.razonSocial,e)}>
                                {cli.razonSocial}
                              </MenuItem>
                            ))
                          )
                        }
                      </Select> 
                    </> 
                   : 
                  <TextField
                    disabled
                    id="listaC"
                    label="Cliente"
                    //value={(e) => setClientes(opcion,e)} 
                    defaultValue= {us.clienteRol[0].cliente.razonSocial}
                    variant="outlined"                    
                  />)
                  : 
                  <TextField
                    disabled
                    id="listaC"
                    label="Cliente"
                    /* value={(e) => setClientes(opcion,e)} */ 
                    defaultValue= {usuario.clienteRol[0].cliente.razonSocial}
                    variant="outlined"                    
                  />
              }
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={1}  display="row" justify="center" alignItems="center">
          <Grid item xs={5} md={2} lg={2}>
            <TextField margin="normal" helperText=" " id="standard-required" label="Cod. País" defaultValue="+549" variant="outlined" InputProps={{
                                readOnly: true,}}/>
            </Grid>
          <Grid item xs={5} md={3} lg={3}>
            <InputMask
              maskChar= ""
              mask="\09999"
              value={usuario.codigoArea}
              onChange={onChange}
            >
              {() => (
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="codigoArea"
                  label="Código Área"
                  id="codigoArea"
                  margin="normal"
                  type="text"
                  helperText=" "
                />
              )}
              </InputMask>
            </Grid>
          <Grid item xs={10} md={5} lg={5}>
            <InputMask
              maskChar= ""
              mask="1\599999999"
              value={usuario.numeroTelefono}
              onChange={onChange}
            >
              
              {() => (
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="numeroTelefono"
                  label="Número"
                  id="numeroTelefono"
                  helperText="Aseguresé de ingresarlo correctamente, caso contario no podra recibir alertas via SMS"
                  type="text"
                />
              )}
            </InputMask>
            </Grid>
        </Grid>
        <Grid container  display="row" justify="center" alignItems="center">
          <Grid item xs={12} md={12} lg={12}>
            <div className={classes.paper}>
              {alerta ? (alerta.categoria==="error" ? (
                  <MensajeAlerta categoria={alerta.categoria} mensaje={alerta.msg}/>
              ) : <MensajeAlerta categoria={alerta.categoria} mensaje={alerta.msg} close={props.onClose}/>
              ) : null}  
              </div>
          </Grid> 
          <Grid item xs={6} justify="center">
              <DialogActions >
              <BotonLoading texto={"Guardar"} disabled={false} load={alerta} onClick={onSubmit}/>
                {/* <Button
                  margin="normal"
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  style={{width:"100%",color:"#FCFCFC",backgroundColor: "#0B3845" }}
                >
                  Guardar
                </Button> */}
              </DialogActions>
          </Grid>
        </Grid>
      </Grid>
    </div>
  </>
  );
}